(() => {
  const OPEN_CLASS = 'is-open';
  const HIDDEN_CLASS = 'mfp-hide';
  const OVERLAY_ID = 'popup-overlay';
  const POPUP_SELECTOR = '.white-popup, [data-popup]';
  const FOCUSABLE = 'a[href], button:not([disabled]), textarea, input, select, [tabindex]:not([tabindex="-1"])';

  let activePopup = null;
  let lastTrigger = null;
  let overlayEl = null;

  // Crea (si no existe) el overlay
  function ensureOverlay() {
    if (overlayEl) return overlayEl;
    overlayEl = document.createElement('div');
    overlayEl.id = OVERLAY_ID;
    overlayEl.className = 'popup-overlay';
    overlayEl.addEventListener('click', closePopup);
    return overlayEl;
  }

  function getTargetFromLink(link) {
    const href = link.getAttribute('href') || '';
    if (!href.startsWith('#') || href === '#') return null;
    const el = document.querySelector(href);
    if (!el) return null;
    // solo interceptamos si es un popup (clase white-popup o data-popup)
    if (!el.matches(POPUP_SELECTOR)) return null;
    return el;
  }

  function openPopup(el, trigger = null) {
    if (activePopup === el) return;

    // overlay
    const overlay = ensureOverlay();
    document.body.appendChild(overlay);

    // muestra popup
    el.classList.add(OPEN_CLASS);
    el.classList.remove(HIDDEN_CLASS);
    el.setAttribute('aria-hidden', 'false');

    // control scroll
    document.documentElement.classList.add('no-scroll');
    document.body.classList.add('no-scroll');

    // focus inicial
    const firstFocusable = el.querySelector(FOCUSABLE);
    (firstFocusable || el).focus({ preventScroll: true });

    // guarda referencias
    activePopup = el;
    lastTrigger = trigger;

    // cerrar con ESC
    document.addEventListener('keydown', onKeydown);

    // cerrar si clic en botón con .popup-close o [data-close]
    el.addEventListener('click', onInsideClick, { once: false });

    // evita que clics dentro burbujeen al overlay
    //el.addEventListener('click', (e) => e.stopPropagation());
  }

  function closePopup() {
    if (!activePopup) return;

    // ocultar
    activePopup.classList.remove(OPEN_CLASS);
    activePopup.setAttribute('aria-hidden', 'true');
    if (activePopup.classList.contains(HIDDEN_CLASS) === false) {
      activePopup.classList.add(HIDDEN_CLASS); // por compatibilidad con tu markup
    }

    // quitar overlay
    if (overlayEl && overlayEl.parentNode) overlayEl.parentNode.removeChild(overlayEl);

    // scroll back
    document.documentElement.classList.remove('no-scroll');
    document.body.classList.remove('no-scroll');

    // focus back al trigger
    if (lastTrigger) {
      try { lastTrigger.focus({ preventScroll: true }); } catch(err) {}
    }

    // limpia
    document.removeEventListener('keydown', onKeydown);
    activePopup.removeEventListener('click', onInsideClick);
    activePopup = null;
    lastTrigger = null;
  }

  // focus trap + ESC
  function onKeydown(e) {
    if (!activePopup) return;
    if (e.key === 'Escape') {
      e.preventDefault();
      closePopup();
      return;
    }
    if (e.key === 'Tab') {
      const focusables = Array.from(activePopup.querySelectorAll(FOCUSABLE))
        .filter(el => el.offsetParent !== null || el === document.activeElement);
      if (focusables.length === 0) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];

      if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault(); first.focus();
      } else if (e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      }
    }
  }

  function onInsideClick(e) {
    const closeBtn = e.target.closest('.popup-close, [data-close]');
    if (closeBtn) {
      e.preventDefault();
      closePopup();
    }
  }

  // Intercepta clics en cualquier <a href="#algo"> cuyo target sea popup
  document.addEventListener('click', (e) => {
    const link = e.target.closest('a[href^="#"]');
    if (!link) return;

    const target = getTargetFromLink(link);
    if (!target) return; // no es popup → comportamiento normal

    e.preventDefault();
    openPopup(target, link);
  });

  // Opcional: abrir si la URL ya viene con el hash de un popup (ej. .../#login-popup)
  window.addEventListener('DOMContentLoaded', () => {
    const hash = window.location.hash;
    if (!hash) return;
    const el = document.querySelector(hash);
    if (el && el.matches(POPUP_SELECTOR)) {
      openPopup(el, null);
    }
  });
})();


// Click en #RecoverPassword: ocultar login y mostrar recover (sin toggle)
document.addEventListener('click', (e) => {
  const trigger = e.target.closest('#RecoverPassword'); // solo por id
  if (!trigger) return;

  e.preventDefault();

  const popup = trigger.closest('.white-popup') || document;
  const loginForm   = popup.querySelector('#CustomerLoginForm');
  const recoverForm = popup.querySelector('#RecoverPasswordForm');
  if (!loginForm || !recoverForm) return;

  loginForm.classList.add('hidden');
  loginForm.setAttribute('aria-hidden', 'true');

  recoverForm.classList.remove('hidden');
  recoverForm.setAttribute('aria-hidden', 'false');

  const firstInput = recoverForm.querySelector('input, select, textarea, button, [tabindex]:not([tabindex="-1"])');
  if (firstInput) firstInput.focus({ preventScroll: true });
});

// Click en #HideRecoverPasswordLink: mostrar Login y ocultar Recover (sin toggle)
document.addEventListener('click', (e) => {
  const trigger = e.target.closest('#HideRecoverPasswordLink'); // solo por id
  if (!trigger) return;

  e.preventDefault();

  const popup = trigger.closest('.white-popup') || document;
  const loginForm   = popup.querySelector('#CustomerLoginForm');
  const recoverForm = popup.querySelector('#RecoverPasswordForm');
  if (!loginForm || !recoverForm) return;

  recoverForm.classList.add('hidden');
  recoverForm.setAttribute('aria-hidden', 'true');

  loginForm.classList.remove('hidden');
  loginForm.setAttribute('aria-hidden', 'false');

  const firstInput = loginForm.querySelector('input, select, textarea, button, [tabindex]:not([tabindex="-1"])');
  if (firstInput) firstInput.focus({ preventScroll: true });
}, true); // <-- fase de captura


// CARD PRODUCT
document.addEventListener("DOMContentLoaded", (event) => {
  document.addEventListener('click', (e) => {
    const card = e.target.closest('.product-card-wrapper');
    if (!card) return;
    const btn = e.target.closest('.slider-button--prev, .slider-button--next');
    if (!btn) return;

    e.preventDefault();
    card.querySelector('.slider-button--prev').disabled=false;

    const media = btn.closest('.media');
    if (!media) return;

    const imgs = Array.from(media.querySelectorAll('img'));
    if (imgs.length < 2) return;

    // Find current visible index (fallback to 0)
    let current = imgs.findIndex((img) => img.classList.contains('card-visible'));
    if (current < 0) current = 0;

    const dir = btn.classList.contains('slider-button--next') ? 1 : -1;
    const next = (current + dir + imgs.length) % imgs.length;

    // Update classes
    imgs.forEach((img, i) => {
      img.classList.toggle('card-visible', i === next);
      img.classList.toggle('card-hidden', i !== next);
    });
  });
});